import fetch from 'cross-fetch';
import { stringify } from 'query-string';
import { raygun } from '@ynap/clientside-monitoring';
import { FindLoqateAddress, FindItemsEntity, RetrieveLoqateAddress } from '../@types';
import { buildFormattingQuery, getMappedSelectedAddress } from './utils';

export const findAddress: FindLoqateAddress = async (params) => {
    try {
        const { findUrl, serviceKey, text, country, container, limit, language = 'en', sort = false } = params;

        const options = {
            key: serviceKey,
            text,
            container,
            countries: country,
            limit,
            language,
        };

        const response = await fetch(`${findUrl}?${stringify(options)}`);
        const responseJson = await response.json();

        if (response.status >= 400) {
            throw new Error(`findLoqateAddress: Loqate API error: ${response.url}`);
        }

        if (sort && responseJson?.Items?.length > 0) {
            const sortedResponse = responseJson.Items?.sort((a: FindItemsEntity, b: FindItemsEntity) => (a?.Text > b?.Text ? 1 : -1));

            // To sort strings with numbers in a human readable way ['Flat 1', 'Flat 5', 'Flat 10', 'Flat 20', ... ]
            const sortedNums = sortedResponse.sort(
                (a: FindItemsEntity, b: FindItemsEntity) => Number(a.Text.match(/(\d+)/g)?.[0]) - Number(b.Text.match(/(\d+)/g)?.[0]),
            );
            return { Items: sortedNums };
        }

        return responseJson;
    } catch (err) {
        raygun.helpers.agent('send', {
            error: new Error(`Loqate find address error`),
            tags: ['loqate'],
            customData: { error: err },
        });
    }
};

export const retrieveAddress: RetrieveLoqateAddress = async (params) => {
    try {
        const { retrieveUrl, serviceKey, id, addressFieldsMaxChars } = params;

        const options = {
            key: serviceKey,
            id,
        };

        const formattedRetrieveUrl = `${retrieveUrl}?${stringify(options)}${buildFormattingQuery()}`;

        const response = await fetch(formattedRetrieveUrl);

        const responseJson = await response.json();
        if (response.status >= 400) {
            throw new Error(`retrieveLoqateAddress: Loqate API error: ${response.url}`);
        }

        const mappedAddress = getMappedSelectedAddress(responseJson, addressFieldsMaxChars);

        return mappedAddress;
    } catch (err) {
        raygun.helpers.agent('send', {
            error: new Error(`Loqate retrieve address error`),
            tags: ['loqate'],
            customData: { error: err },
        });
    }
};

export const setAddressFinderField = () => ({
    displayType: 'ADDRESS_FINDER',
    mandatory: false,
    type: 'ADDRESS_FINDER',
    wcsType: {
        name: 'Address Finder',
    },
});
